import type { GigMetadata, GigShiftSerializerWithGigs } from "@sidegigllc/api/client";
import * as z from "zod/mini";

export const eventSchema = z.object({
  id: z.string(),
  name: z
    .string()
    .check(
      z.minLength(3, "Event name must be at least 3 characters"),
      z.maxLength(25, "Event name must be 25 characters or less"),
    ),
  organization_id: z.string(),
});

export type EventShiftWithGigs = Omit<GigShiftSerializerWithGigs, "gigs"> & { gigs: Array<GigMetadata> };
